import { Component } from '@angular/core';

@Component({
  selector: 'app-crm-custom-page1',
  templateUrl: './crm-custom-page1.component.html',
  styleUrls: ['./crm-custom-page1.component.css']
})
export class CrmCustomPage1Component {

}
